import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "dropdown-toggle circle_button fw600 fr centered fs12 blueAround",
  style: {
                width: `180px`,
                padding: `5px 12px`,
                marginRight: `10px`,
            }
}
const _hoisted_2 = { style: {"margin-top":"3px","margin-left":"-3px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml3 mr4",
  style: {}
}, "「公開」に変更", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml3 mr4",
  style: {}
}, "「停止中」に変更", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml3 mr4",
  style: {}
}, "公開ページを削除", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref: "dropdown",
    class: "",
    style: {}
  }, {
    dropdown: _withCtx(() => [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openRoom && _ctx.openRoom(...args))),
        class: "fs12 pointer fw600 pad5 fl",
        style: {"line-height":"40px"}
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`),
          width: "16",
          height: "17",
          style: {},
          class: "fl mt5 ml5"
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _hoisted_5
      ]),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.suspendRoom && _ctx.suspendRoom(...args))),
        class: "fs12 pointer fw600 pad5 fl",
        style: {"line-height":"40px"}
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/status_suspend.png`),
          width: "18",
          height: "19",
          style: {},
          class: "fl mt4 ml5"
        }, null, 8, _hoisted_6),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteRoom && _ctx.deleteRoom(...args))),
        class: "fs12 pointer fw600 pad5 fl",
        style: {"line-height":"40px"}
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
          width: "16",
          height: "17",
          style: {},
          class: "fl mt5 ml5"
        }, null, 8, _hoisted_9),
        _hoisted_10,
        _hoisted_11
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, "ステータス: " + _toDisplayString(_ctx.room.public_status_name), 1)
      ])
    ]),
    _: 1
  }, 512))
}